<div class="popup confirmArchetypePopup">
    <div class="confirmArchetypePopup-img" [ngClass]="chosenArchetype"></div>
    <h1 class="confirmArchetypePopup-title _primary" [i18nKey]="title"></h1>

    <p class="confirmArchetypePopup-message"[i18nKey]="'decisions.archetype.popup.confirmation.message'"></p>

    <div class="confirmArchetypePopup-action">
        <button (click)="cancel()" class="button _cancel">{{cancelButtonMessage}}</button>
        <button (click)="confirm()" class="button">{{confirmButtonMessage}}</button>
    </div>
</div>
<div class="overlay"></div>
